import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    CONTRATADO: 'Contratado'
}

export default [
    {
        name: ROUTER_NAMES.CONTRATADO,
        path: '/contratado',
        meta: {
            menu: MENUS.CADASTRO,
            title: 'Contratado',
            searchAlias: 'Contratado',
            searchDescription: 'Veja todas os Contratados cadastrados',
            searchTerms: ['contratado'],
            hasRole: 'role/contratado'
        },
        component: () => import('@/views/Contratado')
    },
]